const SIDEBAR_AUTO_COLLAPSE_MIN_WIDTH = 1024;
const SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH = 1280;
/** Mirrors the layout's resize rule: the desktop sidebar is collapsed between 1024 and 1279px. */
export const isSidebarCollapsedByDefault = (viewportWidth) => viewportWidth !== undefined &&
    viewportWidth >= SIDEBAR_AUTO_COLLAPSE_MIN_WIDTH &&
    viewportWidth < SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH;
